<template>
  <div class="manage_model_dialog main-wrap" v-loading="pageLoading">
    <div style="display: flex; justify-content: center">
      <div class="common_bg manage_top">
        <template v-if="hitsList.length">
          <el-button size="mini" v-for="item in hitsList" :key="item.ruleModelId" @click="getMsg(item)">{{ item.ruleModelName }}</el-button>
        </template>
        <template v-else> 暂无命中项 </template>
      </div>
    </div>
    <div class="common_bg manage_bottom" style="margin-top: 10px">
      <ul class="message_list" ref="messageList">
        <li v-for="(item, index) in messagesList" :key="index" ref="messageItem" class="message_item">
          <!-- 客户 -->
          <div class="manage_left" v-if="item.senderRole === 'B'">
            <el-avatar icon="el-icon-user-solid"></el-avatar>
            <div style="margin-left: 10px">
              <div style="margin-bottom: 5px">
                <span>{{ item.senderName }}</span
                ><span style="margin-left: 10px">{{ item.senderTime }}</span>
              </div>
              <div class="manage_bg">
                <span v-if="item.formatContent" v-html="item.formatContent"></span>
                <span v-else-if="item.globalIndexEnd">{{ item.content }}</span>
                <FileCard v-else-if="item.contentType === 'FILE'" :data="item" />
                <div v-else style="width: 100px; height: 100px">
                  <el-image style="width: 100%; height: 100%" :src="item.content" @click="$preview([item.content])" />
                </div>
              </div>
            </div>
          </div>
          <!-- 坐席 -->
          <div class="manage_right" v-if="['A', 'R'].includes(item.senderRole)">
            <div style="margin-right: 10px">
              <div style="margin-bottom: 5px; text-align: right">
                <span>{{ item.senderTime }}</span
                ><span style="margin-left: 10px">{{ item.senderName }}</span>
              </div>
              <div class="manage_bg">
                <span v-if="item.formatContent" v-html="item.formatContent"></span>
                <span v-else-if="item.globalIndexEnd">{{ item.content }}</span>
                <FileCard v-else-if="item.contentType === 'FILE'" :data="item" />
                <div v-else style="width: 100px; height: 100px">
                  <el-image style="width: 100%; height: 100%" :src="item.content" @click="$preview([item.content])" />
                </div>
              </div>
            </div>
            <el-avatar icon="el-icon-user-solid"></el-avatar>
          </div>
          <!-- 模型命中标记 -->
          <template v-if="item.senderRole === 'desc' && item.desc">
             <div class="class-desc">
              <div class="desc-item">{{ item.desc }}</div>
             </div>
          </template>
          <!-- 静默时间 -->
          <template v-if="item.senderRole === 'silenceTime' && item.silenceTimeDesc">
             <div class="class-desc">
              <div class="desc-item silenceTimeDesc-item">{{ item.silenceTimeDesc }}</div>
             </div>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { modelGroupApi } from './pool'
import { RESPONSE_CODE } from '@public/http/config'
import FileCard from './FileCard.vue';
import viewMixin from './_mixins/viewMixin'

export default {
  name: 'ModelPreview',
  components: {
    FileCard
  },
  mixins: [viewMixin],
  data() {
    return {
      COM_HTTP: modelGroupApi,
      hitsList: [], // 命中关键字
      messagesList: [], // 对话
      pageLoading: true
    }
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  watch: {
    '$route.query.taskId': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getView()
        }
      },
      deep: true
    },
    '$route.params.id': {
      handler(newVal, oldVal) {
        if (newVal && oldVal && newVal !== oldVal) {
          this.getView()
        }
      },
      deep: true
    }
  },
  created() {
    this.getView()
  },
  methods: {
    getMsg(item) {
      const first = item.keywords[0]?.indexes[0]
      const target = this.messagesList.findIndex((msg) => typeof msg.globalIndexEnd === 'number' && msg.globalIndexEnd >= first.end - 1)
      this.$refs.messageList.scrollTop = this.$refs.messageItem[target].offsetTop
    },
    // 获取语音对话内容
    async getView() {
      let taskId = null
      let extRuleModel = null
      if (this.type === 'viewPage') {
        taskId = this.$route.params.id
      } else {
        taskId = this.$route.query.taskId
        extRuleModel = JSON.parse(sessionStorage.getItem(taskId))
      }
      if (!taskId) return
      this.pageLoading = true
      const { code, data, msg } = await this.COM_HTTP.reqView({ id: taskId, extRuleModel })
      if (code === RESPONSE_CODE.SUCCESS) {
        this.pageLoading = false
        const { sessionMessages, detects } = data
        const detect = detects.filter((o) => {
          return o.type === 'PREVIEW' || o.type === 'CP_RECHECKED'
        })
        const hits = []
        detect.map((res) => {
          hits.unshift(...res.hits)
        })
        // 右侧tab引用,返回个数
        if (this.type === 'viewPage') {
          this.$emit('postModelData', {
            total: hits.length || 0
          })
        }
        this.setTextHighlight(hits, sessionMessages)
        this.hitsList = hits || []
        const dimensionsArr = hits.reduce((preHit, currHit) => {
          return [...preHit, ...(currHit.dimensions || [])]
        }, [])
        // 模型命中标记
        dimensionsArr?.forEach(res => {
          const bFindIndex = sessionMessages?.findIndex(item => item?.globalIndexBegin === res?.index)
          const eFindIndex = sessionMessages?.findIndex(item => item?.globalIndexEnd === res?.index)
          let setIndex = null
          if (bFindIndex > -1) {
            setIndex = bFindIndex
          }
          if (eFindIndex > -1) {
            setIndex = eFindIndex + 1
          }
          if (setIndex || setIndex === 0) {
            res.senderRole = 'desc'
            sessionMessages?.splice(setIndex, 0, res);
          }
        })
        // 添加静默时间
        const silenceTimeArr = [...sessionMessages]
        silenceTimeArr.forEach((itemTIme) => {
          if (itemTIme?.silenceTimeDesc) {
            // 如果上面有静默时长,不需要添加
            let setIndex = sessionMessages?.findIndex(item => item?.id === itemTIme?.id)
            if (setIndex !== 0 && sessionMessages[setIndex - 1].senderRole === 'desc') {
              setIndex = null
            }
            const setItem = {
              senderRole: 'silenceTime',
              silenceTimeDesc: itemTIme.silenceTimeDesc
            }
            if (setIndex) {
              sessionMessages?.splice(setIndex, 0, setItem);
            }
          }
        })
        this.messagesList = sessionMessages || []
      } else {
        this.$message.error(msg)
        this.pageLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.manage_model_dialog {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ul{
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .class-desc{
    display: flex;
    align-items: center;
    margin: 10px auto;
    .desc-item{
      border: 1px solid #ccc;
      padding: 3px 10px;
      border-radius: 4px;
      display: inline-block;
      margin: 0 auto;
      color: red;
    }
    .silenceTimeDesc-item{
      color:#ccc;
    }
  }
  .manage_top {
    text-align: center;
    display: flex;
    overflow-x: auto;
    justify-content: center;
  }
  .manage_bottom {
    flex: 1 1;
    overflow: hidden;
    .message_list {
      height: 100%;
      position: relative;
      overflow-y: auto;
      .message_item {
        .manage_left {
          display: flex;
          margin-bottom: 20px;
        }
        .manage_right {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 20px;
        }
        .manage_bg {
          min-width: 100px;
          // @include bg-color-base('input');
          padding: 10px;
          border-radius: 10px;
        }
      }
    }
  }
  .common_bg {
    width: 100%;
    border: 1px solid #ccc;
    box-sizing: border-box;
    padding: 15px;
    border-radius: 10px;
  }
}
</style>
